import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import { yieldTypes } from '../../screens/OxygenYield/constants';
import OxygenYield from '../../screens/OxygenYield';
import FAQ from '../../screens/OxygenYield/FAQ';

const OxygenYieldRouter = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/`}>
        <Redirect to={`${path}/${yieldTypes.OFFERS}`} />
      </Route>
      <Route exact path={`${path}/:yieldType`}>
        <OxygenYield />
      </Route>
      <Route exact path={`${path}/:yieldType/faq`}>
        <FAQ />
      </Route>
    </Switch>
  );
};

export default OxygenYieldRouter;
